import { createContext, useCallback, useState } from 'react';

type FuseAdsContextProps = {
  registeredFuseIds: string[];
  addRegisteredFuseId: (n: string) => void;
};

export const FuseAdsContext = createContext<FuseAdsContextProps>({
  registeredFuseIds: [],
  addRegisteredFuseId: () => '',
});

/**
 * Only updates when page transition has happened NOT on first page change
 * At start state will be 0, then page change state will be either 1 or two.
 * Can check if page has changed wuth useEffect
 */
export const FuseAdsProvider = ({ children }: { children: JSX.Element }) => {
  const [registeredFuseIds, setRegisteredFuseIds] = useState<string[]>([]);

  const addRegisteredFuseId = useCallback((n: string) => {
    setRegisteredFuseIds((c) => {
      if (!c.includes(n)) {
        const newArray = c.concat(n);
        return newArray;
      }
      return c;
    });
  }, []);

  /** If number is 1 or 2 page has changed */
  return (
    <FuseAdsContext.Provider value={{ registeredFuseIds, addRegisteredFuseId }}>{children}</FuseAdsContext.Provider>
  );
};
